<template>
  <div>
    <headingComp :heading="'Informação Geral'" :icon="require('@/assets/ic-white-info-geral.svg')" :backgroundImage="require('@/assets/elvas-castelo.jpg')"/>
    <section class="content-container">
      <div class="sidebar">
        <ol>
          <li @click="scrollTo('.como-chegar-container')">Como chegar</li>
          <li @click="scrollTo('.visitas-guiadas')">Visitas Guiadas</li>
          <li @click="scrollTo('.meteorologia')">Metereologia</li>
          <li @click="scrollTo('.farmacias')">Farmácias</li>
          <li @click="scrollTo('.celebracoes')">Festas e Feriados</li>
        </ol>
      </div>
      <div class="container">
        <div class="como-chegar-container">
          <h4 class="title">Como chegar</h4>
          <article class="como-chegar-item">
            <h4>Carro</h4>
            <p class="type">Auto-Estrada</p>
            <p>Suspendisse accumsan odio vel tempor, eu luctus enim viverra. Vestibulum at vulputate nisl.</p>
          </article>
           <article class="como-chegar-item">
            <h4>Autocarro</h4>
            <a href="www.rede-expresso.pt" class="type">www.rede-expresso.pt</a>
            <p>Suspendisse accumsan odio vel tempor, eu luctus enim viverra. Vestibulum at vulputate nisl.</p>
          </article>
           <article class="como-chegar-item">
            <h4>Comboio</h4>
            <a href="www.cp.pt" class="type">www.cp.pt</a>
            <p>Suspendisse accumsan odio vel tempor, eu luctus enim viverra. Vestibulum at vulputate nisl.</p>
          </article>
        </div>
      </div>
      <div class="visitas-guiadas">
        <h4 class="title title-align-right">Visitas Guiadas</h4>
        <div class="guia-turistico">
          <img class="image" src="@/assets/elvas-fortedagrac-a-04@3x.jpg">
          <div class="text">
            <h4>Guia turístico</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
            <div class="contact">
              <h5>Contacto</h5>
              <p>geral@mail.com</p>
              <p>+351 000 000 000</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="meteorologia">
      <h4 class="title title-align-right">Meteorologia</h4>
      <section class="months-container">
        <line-chart :styles="chartStyles"/>
        <!-- <div class="month" v-for="month in months" :key="month">
          <div class="image"></div>
          <p class="month-name">{{month}}</p>
        </div> -->
      </section>
    </div>
    <div class="farmacias">
      <h4 class="title">Farmácias</h4>
      <section class="farmacias-container">
        <div class="farmacia">
          <div class="image"></div>
          <h5 class="farmacia-name">Farmácia #1</h5>
          <p class="address">R. da Cadeia,<br> 7350-148 Elvas</p>
          <div class="show-on-map">
            <p>Mostrar no mapa</p>
            <img src="@/assets/arrow-orange.svg">
          </div>
        </div>
        <div class="farmacia">
          <div class="image"></div>
          <h5 class="farmacia-name">Farmácia #2</h5>
          <p class="address">R. da Cadeia,<br> 7350-148 Elvas</p>
          <div class="show-on-map">
            <p>Mostrar no mapa</p>
            <img src="@/assets/arrow-orange.svg">
          </div>
        </div>
        <div class="farmacia">
          <div class="image"></div>
          <h5 class="farmacia-name">Farmácia #3</h5>
          <p class="address">R. da Cadeia,<br> 7350-148 Elvas</p>
          <div class="show-on-map">
            <p>Mostrar no mapa</p>
            <img src="@/assets/arrow-orange.svg">
          </div>
        </div>
      </section>
    </div>
    <div class="celebracoes">
      <h4 class="title">Celebrações e Feriados</h4>
      <section class="celebracoes-container">
        <div class="celebracao">
          <div class="image"></div>
          <h5 class="celebracao-name">Celebração</h5>
          <p class="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
        </div>
        <div class="celebracao">
          <div class="image"></div>
          <h5 class="celebracao-name">Celebração</h5>
          <p class="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
        </div>
        <div class="celebracao">
          <div class="image"></div>
          <h5 class="celebracao-name">Celebração</h5>
          <p class="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import LineChart from '../util/weather-chart'

export default {
  name: 'eventosActividade',
  props: [],
  components: {
    LineChart
  },
  data() {
    return {
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    }
  },
  mounted () {
  },
  methods: {
    scrollTo (key) {
      this.$el.querySelector(key).scrollIntoView({behavior: 'smooth'})
    }
  },
  computed: {
    chartStyles () {
      return {
        height: '300px',
        width: '100%',
        position: 'relative'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 80px;
  display: table;
}
h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
}

.title {
  position: absolute;
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: -2px;
  right: 0;
  top: -45px;
  z-index: 1;
  color: #f6b92f;
}
.title-align-right {
  right: 5%;
}
.content-container {
  display: flex;
  margin-top: 125px;
  flex-wrap: wrap;
  .sidebar {
    width: 25%;
    ol {
      margin-left: 20px;
      li {
        font-size: 24px;
        font-weight: bold;
        padding: 5px 0;
        color: #f6b92f;
        opacity: 0.5;
        cursor: pointer;
      }
      li.active, li:hover {
        opacity: 1;
      }
    }


  }
  .container {
    width: 70%;
    .como-chegar-container {
      position: relative;
      display: flex;
      padding-top: 20px;
      .como-chegar-item {
        width: calc(100% / 3 - 30px);
        margin: 0 15px;
        .image {
          width: 100%;
          height: 225px;
          background: rgba(0, 0, 0, 0.1);
        }
        h4 {
          margin-top: 20px;
          font-weight: bold;
          font-size: 18px;
          color: #a79374;
        }
        .type {
          margin: 5px 0 16px 0;
          color: #a79374;
          display: block;
        }
      }
      @media screen and (max-width: 550px){
        flex-direction: column;

        .como-chegar-item {
          width: 90%;
        }
      }
    }   
  }
  .visitas-guiadas {
    margin-top: 150px;
    position: relative;
    width: 70%;
    margin-left: auto;
    padding-right: 5%;
    background: #f6ede0;
    .guia-turistico {
      margin-top: -20px;
      display: flex;
      .image {
        width: 40%;
        background: rgba(0, 0, 0, 0.1);
        margin: 5%;
        object-fit: cover;
      }
      .text {
        width: 60%;
        padding: 5% 0 5% 40px;
        display: flex;
        flex-direction: column;
        & > p {
          line-height: 24px;
        }
        h4 {
          font-weight: bold;
          font-size: 42px;
          margin-bottom: 40px;
          color: #a79374;
          line-height: 1.19;
          letter-spacing: -0.95px;
        }
        .contact {
          margin-top: auto;
          & > * {
            padding: 5px 0;
          }
          h5 {
            color: #a79374;
            font-weight: bold;
            font-size: 18px;
          }
        }
      }
    }

    @media (max-width: 1000px){
      width: 80%;
    }

    @media (max-width: 750px){
      width: 100%;
      padding: 0;
      margin: 0 16px;
      margin-top: 150px;
    }
  }

  @media (max-width: 700px){
    margin-top: 20px;
    .sidebar {
      width: 100%;
      margin-bottom: 48px;

      ol {
        display: flex;

        li {
          flex: 1;
          font-size: 18px;
          text-align: center;

          & + li {
            margin-left: 16px;
          }
        }
      }
    }
    .container {
      width: 100%;
      .como-chegar-container{
        padding-top: 0;
        margin-top: 30px;
        h4 {
          font-size: 32px;
          left: 16px;
          top: -28px;
        }
      }
    }
    .visitas-guiadas {
      margin-top: 75px;
      .title {
        font-size: 32px;
        top: -38px;
        left: 0;
      }
    }
  }

  @media (max-width: 650px){
    .visitas-guiadas .guia-turistico {
      flex-direction: column;
      .image {
        width: 90%;
        margin-bottom: 0;
      }
      .text {
        width: 90%;

        h4 {
          margin-bottom: 16px;
        }
      }
    }
  }

  @media (max-width: 550px){
    margin-top: 56px;
    .sidebar{
      display: none;
    }
  }
}
.meteorologia {
  width: 100%;
  margin-top: 150px;
  position: relative;
  .months-container {
    display: flex;
    .month {
      width: calc(100% / 12);
      .image {
        background: #f6ede0;
        width: 100%;
        height: 200px;
      }
    }
  }

  @media (max-width: 1000px){
    .months-container {
      overflow-y: auto;
      padding-bottom: 8px;
      .month {
        min-width: calc(100% / 8);
      }
    }
  }

  @media (max-width: 700px){
    margin-top: 75px;
    h4 {
      font-size: 32px;
      left: 16px;
      top: -38px;
    }
    .months-container {
      .month {
        min-width: calc(100% / 6);
      }
    }
  }

  @media (max-width: 450px){
    .months-container {
      .month {
        min-width: calc(100% / 4);
      }
    }
  }
}
.farmacias {
  margin: 0 5% 0 25%;
  width: 70%;
  margin-top: 150px;
  position: relative;
  .farmacias-container {
    display: flex;
    .farmacia {
      width: calc(100% / 3 - 30px);
      margin: 0 15px;
      .image {
        width: 100%;
        height: 225px;
        background: #f6ede0;
      }
      h5 {
        margin-top: 20px;
        font-size: 18px;
      }
      .address {
        margin: 10px 0;
        color: #a79374;
      }
      .show-on-map {
        display: flex;
        align-items: center;
        p {
          font-size: 14px;
          font-weight: bold;
          text-transform: uppercase;
          margin-right: 10px;
          color: #f6b92f;
        }
      }
    }
  }

  @media (max-width: 1000px){
    width: 80%;
    margin: 0 8px 0 auto;
    margin-top: 150px;
  }

  @media (max-width: 750px){
    width: 100%;
    margin: 0 auto;
    margin-top: 150px;
  }

  @media (max-width: 700px){
    margin-top: 75px;
    h4 {
      font-size: 32px;
      left: 16px;
      top: -38px;
    }
  }

  @media (max-width: 600px){
    .farmacias-container  {
      overflow-y: auto;
      padding-bottom: 16px;

      .farmacia {
        min-width: calc(100% / 1.75 - 30px);
      }
    }
  }
}
.celebracoes {
  margin: 0 5%;
  width: 90%;
  margin-top: 150px;
  margin-bottom: 150px;
  position: relative;
  .celebracoes-container {
    display: flex;
    .celebracao {
      width: calc(100% / 3 - 30px);
      margin: 0 15px;
      .image {
        width: 100%;
        height: 275px;
        background: #f6ede0;
      }
      h5 {
        margin-top: 20px;
        font-size: 24px;
        color: #a79374;
        line-height: 1.17;
        letter-spacing: -0.55px;
      }
      .description {
        line-height: 22px;
        margin: 10px 0;
      }
    }
  }

  @media (max-width: 700px){
    width: calc(100%);
    margin: 0 auto;
    margin-top: 75px;
    .title {
      font-size: 32px;
      left: 16px;
      top: -38px;
    }
  }

  @media (max-width: 600px){
    margin-bottom: 120px;
    .celebracoes-container  {
      overflow-y: auto;
      padding-bottom: 16px;
      .celebracao {
        min-width: calc(100% / 1.75 - 30px);
      }
    }
  }
}
</style>